function scrollToTop() {
	document.documentElement?.scrollTo(0, 0);
}

export { scrollToTop };
